<template>
  <div class="container text-glow">
    <!-- Begin Mailchimp Signup Form -->
    <div id="mc_embed_signup">
      <form
        action="https://overlook-studios.us20.list-manage.com/subscribe/post?u=5e2a27f961b4e9bcae751e40b&amp;id=6f7d4a0b2c"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        class="validate"
        target="_blank"
        novalidate
      >
        <div id="mc_embed_signup_scroll">
          <div class="mc-field-group">
            <label for="mce-EMAIL" class="email-address">> Email Address</label>
            <br />>
            <input
              type="email"
              value
              name="EMAIL"
              spellcheck="false"
              class="required email"
              id="mce-EMAIL"
            />
          </div>
          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true">
            <input type="text" name="b_5e2a27f961b4e9bcae751e40b_6f7d4a0b2c" tabindex="-1" value />
          </div>
          <div class="clear">
            >
            <input
              type="submit"
              value="Subscribe"
              name="subscribe"
              id="mc-embedded-subscribe"
              class="button"
            />
          </div>
          <div id="mce-responses" class="clear">
            <div class="response" id="mce-error-response" style="display:none">BAD</div>
            <div class="response" id="mce-success-response" style="display:none">GOOD</div>
          </div>
        </div>
      </form>
    </div>

    <!--End mc_embed_signup-->
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";
.container {
  font-size: 40px;
}

.required.email {
  width: 80%;
  background-color: black;
  border-radius: 5px;
  font-size: smaller;
  box-shadow: $text-shadow-low;
  font-family: inherit;
  color: inherit;
  caret-color: $green;
  padding: 0px;
  padding-left: 10px;
  transition: 0.3s all;
  text-decoration: none;
  padding-top: 2px;
  padding-bottom: 2px;
}
.required.email:focus {
  outline: none;
  box-shadow: $text-shadow;
}
.required.email:hover {
  box-shadow: $text-shadow;
}

.required.email::selection {
  background-color: rgba($green, 0.1);
}

.button,
.required.email {
  margin-top: 5px;
  border: 3px solid rgba($green, 0.3);
}
.button {
  border-radius: 5px;
  background-color: black;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  padding: 0px;
  margin-top: 7px;
  cursor: pointer;
  line-height: 0.9;
  padding-left: 5px;
  padding-right: 5px;
  transition: 0.3s all;
}
.button:focus {
  outline: none;
}
.button:hover {
  background-color: rgba($green, 0.01);
  color: rgba($green, 0.5);
}
$errorColor: rgba(red, 0.5);
$successColor: rgba(green, 0.7);
#mce-responses {
  margin-top: 10px;
  #mce-error-response,
  #mce-success-response {
    border: 5px solid black;
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    text-shadow: none;
  }
  #mce-error-response {
    border-color: $errorColor;
    color: $errorColor;
  }
  #mce-success-response {
    border-color: $successColor;
    color: $successColor;
  }
}
</style>